import { css } from '@emotion/react';

import { skeletonLoading } from 'src/styles/styles';

import { colors } from '../../../../styles/colors';
import { ZeeFontBold, ZeeFontRegular } from '../../../../styles/font';
import { MediaBP as MQ } from '../../../../styles/mediaQuery';
export const contentItemPopUp = css`
  opacity: 0;
  padding: 0px 1px 10px 10px;
  background-color: ${colors.white};
  width: 100%;
  height: 100%;
  color: ${colors.black};
  filter: blur(20px);
  text-align: left;
  transition: opacity 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), transform 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), filter 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
    background-color 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
    border-radius 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  & h3 {
    font-size: 10px;
    font-weight: 700;
    line-height: 1.4em;
    ${ZeeFontBold(10, 20)}
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    color: ${colors.AccentDarkGrayColor};
  }
`;

export const contentItemPopUpWrapper = css`
  position: relative;
  width: 100%;
  align-self: stretch;
  footer {
    position: absolute;
    left: 0;
    top: 0;
    margin-left: 10px;
  }
`;

export const episodeTitle = css`
  ${ZeeFontRegular(14, 20)}
  color: hsla(0,0%,100%,.5);
  margin-top: 5px;
`;

export const contentItemCard = css`
  display: flex;
  flex-direction: row;
  position: relative;
  margin: 8px;
  cursor: pointer;
  width: 100%;
  height: fit-content;
  align-items: stretch;
  &:after {
    content: '';
    position: absolute;
    border-radius: 12px;
    border: 0 solid ${colors.white};
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }
  img {
    border: 1px solid rgba(255, 255, 255, 0.32);
  }
  ${MQ.MediaLg} {
    &:hover {
      transition: all;
      transition: transform 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
      z-index: 100;
      & footer {
        opacity: 0;
        transition-delay: 0.4s;
      }
      &:after {
        border: 8px solid ${colors.white};
        transition: border 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
        transition-delay: 0.4s;
        bottom: -7px;
        left: -7px;
        right: -7px;
        top: -7px;
        pointer-events: none;
      }
      figure {
        img {
          transform: scale(0.98);
          transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          transition-delay: 0.4s;
        }
      }
      .popup-content {
        opacity: 1;
        transition: opacity 0.25s ease-in,
          bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
          transform 0.25s ease-in,
          bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
          filter 0.25s ease-in,
          bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
          background-color 0.25s ease-in,
          bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
          border-radius 0.25s ease-in,
          bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
        transition-delay: 0.4s;
        filter: inherit;
        z-index: 2;
      }
    }
  }
`;

export const thumbnailTitleWrapper = css`
  ${ZeeFontRegular(14, 20)};
  max-height: 40px;
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const thumbnailTitleDate = css`
  color: ${colors.white};
`;
export const thumbnailTitle = css`
  color: ${colors.greyText};
`;
export const skeletonWrapper = css`
  display: flex;
  flex-direction: row;
  position: relative;
  margin: 8px;
  cursor: pointer;
  flex-basis: calc(100% - 20px);
  height: fit-content;
  align-items: stretch;
  gap: 10px;
  footer {
    flex: 1;
  }
`;
export const skeletonContent = css`
  z-index: 0;
  overflow: hidden;
  background: ${colors.TemplateLoaderTrayBgDesktop};
  border-radius: 6px;
  ${skeletonLoading};
`;
export const skeletonCard = css`
  position: relative;
  ${MQ.MediaLg} {
    width: 168px;
  }
`;
export const skeletonCardTitle = css`
  &::before {
    content: '';
    border-radius: 6px;
    background-color: ${colors.TemplateLoaderAccent};
    width: 60%;
    height: 10px;
    display: block;
    margin-bottom: 13px;
  }
`;
export const skeletonCardTagWrapper = css`
  display: flex;
  align-items: center;
  gap: 10px;
`;
export const skeletonCardTag = css`
  &::before {
    content: '';
    border-radius: 6px;
    background-color: ${colors.TemplateLoaderAccent};
    width: 40px;
    height: 10px;
    display: block;
    margin-bottom: 13px;
  }
`;
